module.exports = __webpack_public_path__ + "static/media/stats-chart.f9b06e35.svg";